import styled from "styled-components";

export const TableContainer = styled.div`
    display: flex;
    height: 100%;
    padding: 8px;

    .templatePreviewWrapper {
        width: 68px;
        height: 64px;
    }
    .cellWrapperCustomTable {
        padding: 0;
    }
    .typography-text-box {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
 
`;

export const EmptyStateContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 54px 8px;
    justify-content: center;
    height: 100%;
`;
